import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/core/loading/services/loading.service';

@Component({
    selector: 'dk-multiselect',
    templateUrl: './dk-multiselect.component.html',
    styleUrl: './dk-multiselect.component.scss',
    standalone: false
})
export class DkMultiselectComponent implements OnInit, OnChanges {
  /* -------------------------------------------------------------------------- */
  /*                                    label                                 */
  /* ------------------------------------------------------------------------ */
  @Input() public label: string;

  // /* -------------------------------------------------------------------------- */
  // /*                               bootstrap grid                               */
  // /* -------------------------------------------------------------------------- */

  @Input() public col = '12'; // mobile
  @Input() public sm = '12'; // small
  @Input() public md = '12'; // medium
  @Input() public lg = '12'; // medium
  @Input() public xl = '12'; // extra large

  @Input() public has_my3 = false;
  @Input() public has_mb3 = false;

  /* -------------------------------------------------------------------------- */
  /*                                    form                                    */
  /* -------------------------------------------------------------------------- */

  @Input() public formGroup: FormGroup;
  @Input() public controlName: string;
  @Input() public autocomplete = 'off';
  @Input() public type = 'text';
  @Input() public placeholder = '';
  @Input() public disabled = false;
  @Input() public autoFocus = false;
  @Input() virtualScroll = false;
  @Input() virtualScrollItemSize = 10;
  @Input() appendTo: any = 'body';

  @Input() group = false;
  @Input() groupLabelKey: string;
  @Input() groupValueKey: string;
  @Input() childrenProperty: string;

  @Input() id: string; // the id of options
  @Input() dataKey: string; // the unique property of each option
  @Input() optionLabel: string; // the label of option that we see
  @Input() optionValue: string; // the value of option that we see
  @Input() imageBaseSrc: string;
  @Input() imageKey: string;
  @Input() imageExtension: string;
  @Input() filter = true;
  @Input() options: any = [];
  @Input() loading = false;
  @Input() maxSelectedLabels = 3;
  @Input() emptyMessage: string; // if options were empty
  @Input() emptyFilterMessage: string; // if the result of filter was empty
  @Input() selectedItemsLabel = 'primeng.itemsSelected';
  @Input() scrollHeight = '200px';

  @Output() onChange = new EventEmitter();
  @Output() onSelectAllChange = new EventEmitter();

  @Input() ngModelValue: any;
  @Input() translatePrefix: string;

  /* -------------------------------------------------------------------------- */
  /*                                 constructor                                */
  /* -------------------------------------------------------------------------- */
  constructor(
    private cdref: ChangeDetectorRef,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private translateService: TranslateService,
    private httpClient: HttpClient,
    private loadingService: LoadingService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && this.options?.length > 0) {
      if (this.group) {
        this.options = this.options.map((group: any) => ({
          label: group[this.groupLabelKey],
          value: group[this.groupValueKey],
          items: group[this.childrenProperty],
        }));
      }
    }

    if (changes?.['disabled'] && this.control) {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'col-' + this.col);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-sm-' + this.sm);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-md-' + this.md);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-lg-' + this.lg);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-xl-' + this.xl);
  }

  ngAfterContentChecked(): void {
    // this.cdref.detectChanges();
  }

  get control(): AbstractControl {
    if (this.formGroup && this.controlName) {
      return this.formGroup?.controls[this.controlName];
    }
    return null;
  }

  get required(): boolean {
    if (!this.control?.validator) {
      return false;
    }

    const validator = this.control.validator({} as AbstractControl);
    return validator?.['required'];
  }

  get screenHight() {
    return document.body.clientHeight;
  }
}
